import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Home from '../components/Home';

export default function Index() {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) {
      return;
    }
    const { PRO, admin, clear } = router.query;
    if (clear === 'true') {
      window.localStorage.removeItem('PRO');
      window.localStorage.removeItem('adminCredentials');
    } else {
      if (PRO === 'true') {
        window.localStorage.setItem('PRO', 'true');
      }
      if (typeof admin === 'string' && admin.length > 0) {
        window.localStorage.setItem('adminCredentials', admin);
      }
    }
    if (PRO !== undefined || admin !== undefined || clear !== undefined) {
      const query = { ...router.query };
      delete query.PRO;
      delete query.admin;
      delete query.clear;
      router.replace({ pathname: router.pathname, query }, undefined, { shallow: true });
    }
  }, [router.isReady, router.query, router.pathname]);

  return (
    <>
      <Home />
    </>
  )
}